function init() {
	'use strict';

	document.addEventListener( 'click', function( event ) {
		const heading = event.target.closest( '.filter-panel.is-collapsible .filter-heading' );
		if ( ! heading ) {
			return;
		}

		heading.closest( '.filter-panel' )?.classList.toggle( 'is-collapsed' );
	} );
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
